export default __webpack_public_path__ + "static/media/1.1b471b74.png";